export const isArrayWithLength = (arr) => Array.isArray(arr) && !!arr.length;
export const formatClassNames = (classNameArr) =>
  classNameArr.filter((x) => !!x).join(' ');
export const isObjectWithKeys = (value) =>
  isObject(value) && Object.keys(value).length > 0;
export const isObject = (value) =>
  !!value && typeof value === 'object' && value.constructor === Object;

export const isNonTabletMobileDevice = () => {
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    navigator.userAgent || navigator.vendor
  );
};

export const ENVIRONMENTS = {
  DEV: 'dev',
  TEST: 'test',
  STAGING: 'staging',
  PRODUCTION: 'production',
};

const origin = window.location.origin;
export const environment =
  origin.includes('tt.milwaukeetool.com') || origin.includes('tt-p')
    ? ENVIRONMENTS.PRODUCTION
    : origin.includes('tt-s')
      ? ENVIRONMENTS.STAGING
      : origin.includes('tt-t')
        ? ENVIRONMENTS.TEST
        : ENVIRONMENTS.DEV;
